import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import FiltroComunicados from '../../Filtros/FiltroComunicados';
import InfoComponent from '../InfoComponent';

class ApresentacoesEspeciais extends Component {

	render() {

		return (

			<div>
				{/* HEADER */}{/* LOGIN */}

				<ErrorBoundary>
					<Header />
				</ErrorBoundary>

				<InfoComponent image={"apresentacoes-especiais"} page={'apresentacoes-especiais'}></InfoComponent>
				
				<ErrorBoundary><FiltroComunicados url={"/ObterapresentacoesEspeciais"} urlFiltro={"/ObterapresentacoesEspeciais?"} /></ErrorBoundary>

				{/* Content page */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default ApresentacoesEspeciais;